<template>
	<div>
		<el-button type="text" @click="open">录入客服信息</el-button>
		<el-table :data="formData.servCustList" border style="width: 100%">
		  
			<el-table-column align="center" label="客服专员" prop="servCustUser.nickname" width="55px"/>
			<el-table-column align="center" label="联系时间" prop="concatTime"width="75px"/>
			<el-table-column align="left" label="联系内容" prop="concatText"  width="240px"/>
			<el-table-column align="center" label="下次联系时间" prop="concatTimeNext"width="150px"/>
		</el-table>
		<div class="popup" ref="popup" v-show="showActive">
			<div>
				<p class="form_title">
					客服信息录入
				</p>
				<el-form label-width="120px" :model="edit_form" :rules="edit_rules" ref="formRef">
				<!-- 	<el-form-item label="本次联系时间" prop="contactTime" required>
						<el-date-picker v-model="edit_form.contactTime" type="datetime" placeholder="选择联系时间"
						style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
					</el-form-item> -->
					<el-form-item label="本次联系内容" prop="concatText" required>
						<el-input v-model="edit_form.concatText" type="textarea" :rows="4"
						placeholder="请输入联系内容" />
					</el-form-item>
					<el-form-item label="下次联系时间" prop="concatTimeNext" >
						<el-date-picker v-model="edit_form.concatTimeNext" type="datetime" placeholder="选择下次联系时间"
						style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" />
					</el-form-item>
				</el-form>
				<div>
					<el-button @click="cancle">取消</el-button>
					<el-button type="primary" @click="sub">确认</el-button>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import request from '../utils/request'
	import * as ww from '@wecom/jssdk'
	
	export default {
		props: {
			formData: {
				type: Object,
				required: true,
				default: () => ({}) // 默认值
			},
			
		},
	
		data(){
			return {
				showActive:false,
				tableData: [
					{
						name:'测试客服',
						data:'2025-08-28',
						content:'1',
						data_next:'2025-08-31',
					}
				],
				edit_form: {
					contactTime: '',
					contactContent: '',
					nextContactTime: ''
				},
				edit_rules: {
					
					concatText: [{
						required: true,
						message: '请输入本次联系内容',
						trigger: 'blur'
					}],
				
				},
				formData:{},
			}
		},
		watch: {
			formData: {
				handler(newVal) {
					this.$forceUpdate();
				},
				deep: true // 深度监听对象内部变化
			}
		},
		mounted() {
		
		},
		
		methods: {
		  open() {
			  this.showActive = true
			  // this.$refs.popup
			// this.$alert('<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
			//   dangerouslyUseHTMLString: true
			// });
		  },
		  sub(){
			  var that = this;
			  this.edit_form.orderId = this.formData.id
			  
			const res = request.post('/applets/qywx/serv_cust_edit',this.edit_form)
			.then(response => {
				
				
				this.$message({
				         message: '保存成功',
				         type: 'success'
				       });
					 
					this.getGroupId();
			})
			.catch(error => {
			  console.error('请求失败:', error)
			  return null // 返回默认值，避免链式调用中断
			})
			 
		  },
		  cancle(){
			  this.showActive = false
			  this.edit_form = {
			  	contactTime: '',
			  	contactContent: '',
			  	nextContactTime: ''
			  }
		  },
		  getGroupId()  {
		  	debugger
		  	 const self = this;
		  	try {
		  		ww.getCurExternalChat({
		  			success(result) {
		  				// 成功回调，result.errMsg 固定格式为“方法名:ok”
		  				
		  				self.getDetail(result.chatId);
						self.cancle();
		  			},
		  			fail(result) {	// 失败回调，通过 result.errMsg 查看失败详情
		  				alert(JSON.stringify(result))
		  			},
		  			complete(result) {
		  				// 完成回调，无论调用成功还是失败，都会回调该方法
		  			}
		  		})
		  	} catch (error) {
		  		console.error('获取群ID失败:', error)
		  		localMsg.value = '获取群ID失败' + JSON.stringify(error, null, 2)
		  	}
		  },
		   getDetail(chatId){
		  	 
		  	// 假设是GET请求，使用params传递参数
		  	const res = request.get('/applets/qywx/getchatIdByDetail?chatId='+chatId)
		  	.then(response => {
		  	  console.log('请求成功:', response.data)
		  	  this.formData = response.data;
		  	  // 确保localMsg在当前作用域内已定义（解决潜在的问题2）
		  	  // if (localMsg && localMsg.value !== undefined) {
		  	  //   localMsg.value = response.data
		  	  // }
		  	  return response.data // 通常只需要返回数据，而不是整个response对象
		  	})
		  	.catch(error => {
		  	  console.error('请求失败:', error)
		  	  return null // 返回默认值，避免链式调用中断
		  	})
		  	
		  },
		}
	}
</script>

<style lang="scss">
	.popup{
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, .4);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
		>div{
			width: 80vw;
			height: 80vh;
			box-sizing: border-box;
			background: #fff;
			padding: 40px 10px;
		}
	}
	// .popup::before{
	// 	content: '';
	// 	width: 100vw;
	// 	height: 100vh;
	// 	position: fixed;
	// 	top: 0%;
	// 	left: 0%;
	// 	background: rgba(0, 0, 0, 0.4);
	// 	z-index: 1;
	// }
</style>